var userAgent = require('../internals/engine-user-agent');

module.exports = /web0s(?!.*chrome)/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-is-webos-webkit.js
// module id = 309
// module chunks = 0 1